import { useNavigate } from 'react-router-dom';
import { useState } from 'react';
import {
  Box,
  Button,
  CircularProgress,
  Paper,
  TextField,
  Typography,
} from '@mui/material';
import { toast } from 'material-react-toastify';
import { useThemeColor } from '../../hooks/useThemeColor';
import {
  validateEmail,
  validatePassword,
  validatePhoneNumber,
} from '../../utils/Validation';
import { login, register } from '../../api/Auth';
import { storeToken } from '../../utils/Auth';

export const RegisterForm = () => {
  const navigate = useNavigate();

  const { primary, secondary } = useThemeColor();

  const [email, setEmail] = useState('');
  const [phone, setPhone] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [loading, setLoading] = useState(false);

  const isEmailValid = validateEmail(email);
  const isPasswordValid = validatePassword(password);
  const isPhoneValid = validatePhoneNumber(phone);
  const isConfirmPasswordValid = password === confirmPassword;

  const handleRegister = () => {
    setLoading(true);
    register({ email, phone, password })
      .then(() => {
        toast.success('Başarıyla üyelik oluşturuldu');
        login(email, password)
          .then((token) => {
            storeToken(token);
            navigate('/');
          })
          .finally(() => setLoading(false));
      })
      .catch((err) => {
        toast.error(err.message);
        setLoading(false);
      });
  };

  return (
    <Paper
      elevation={3}
      sx={{
        px: 2.5,
        py: 2,
        boxSizing: 'border-box',
        display: 'flex',
        flexDirection: 'column',
        gap: 2,
        width: '100%',
        height: '100%',
      }}
    >
      <Typography sx={{ fontSize: '1.75rem', fontWeight: 600 }}>
        Kayıt Ol
      </Typography>

      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          gap: 0.5,
          width: '100%',
        }}
      >
        <Typography>E-Posta</Typography>

        <TextField
          size='small'
          fullWidth
          disabled={loading}
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          error={!!email.length && !isEmailValid}
          helperText={
            isEmailValid || !email.length
              ? undefined
              : 'Lütfen geçerli bir e-posta adresi girin.'
          }
        />
      </Box>

      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          gap: 0.5,
          width: '100%',
        }}
      >
        <Typography>Telefon Numarası</Typography>

        <TextField
          size='small'
          fullWidth
          disabled={loading}
          value={phone}
          onChange={(e) => setPhone(e.target.value)}
          error={!!phone.length && !isPhoneValid}
          helperText={
            isPhoneValid || !phone.length
              ? undefined
              : 'Telefon numarası 0 ile başlamalı ve 11 karakter olmalıdır.'
          }
        />
      </Box>

      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          gap: 0.5,
          width: '100%',
        }}
      >
        <Typography>Şifre</Typography>
        <TextField
          size='small'
          fullWidth
          disabled={loading}
          type='password'
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          error={!!password.length && !isPasswordValid}
          helperText={
            isPasswordValid || !password.length
              ? undefined
              : 'Şifre en az 6 karakter uzunluğunda olmalıdır.'
          }
        />
      </Box>

      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          gap: 0.5,
          width: '100%',
        }}
      >
        <Typography>Şifreyi Onayla</Typography>
        <TextField
          size='small'
          fullWidth
          disabled={loading}
          type='password'
          value={confirmPassword}
          onChange={(e) => setConfirmPassword(e.target.value)}
          error={!!password.length && !isConfirmPasswordValid}
          helperText={
            isConfirmPasswordValid || !password.length
              ? undefined
              : 'Şifreler uyuşmuyor.'
          }
        />
      </Box>

      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row',
          gap: 1,
          alignItems: 'center',
        }}
      >
        <Button
          variant='contained'
          onClick={handleRegister}
          disabled={
            loading ||
            !isEmailValid ||
            !isPasswordValid ||
            !isPhoneValid ||
            !isConfirmPasswordValid
          }
          sx={{
            textTransform: 'none',
            backgroundColor: primary,
            color: secondary,
          }}
        >
          Kayıt Ol
        </Button>

        {loading && <CircularProgress color='primary' />}
      </Box>
    </Paper>
  );
};
